export default (styles=[]) => {
  let res = {};
  styles.forEach(styleObj => Object.assign(res, styleObj))
  return res;
}
